import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ChatBubbleSvg = function ChatBubbleSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.785 10.505H7.794V9.097h8.991zM7.794 14.903h6.294v-1.408H7.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.578 12c0-5.247 4.348-9.5 9.711-9.5S22 6.753 22 12s-4.347 9.5-9.71 9.5H2l2.47-3.866A9.33 9.33 0 0 1 2.578 12m9.711-8.093C7.721 3.907 4.017 7.53 4.017 12c0 1.953.707 3.744 1.884 5.143l.33.39-1.635 2.56h7.693c4.569 0 8.272-3.623 8.272-8.093s-3.703-8.093-8.272-8.093",
    clipRule: "evenodd"
  }));
};
export var ChatBubble = function ChatBubble(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ChatBubbleSvg
  }));
};